module.exports = __webpack_public_path__ + "img/sq-11.0bad4a95.jpg";